import Axios from "axios";
import { baseUrl } from "./api";

const instance = Axios.create({
    baseURL: baseUrl,
    headers: {
        Accept: 'application/json',
    },
});


export default instance;